import { createAction } from "@ngrx/store";

export const toggleStatsAction = createAction(
    'TOGGLE_STATS_UI',
)
